// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"538":"6b0b2529","850":"1673d212"}[chunkId] + ".chunk.js";
};